import React, { useContext, useEffect, useRef } from 'react';

import moment from 'moment';
import { AdminContext } from '../../../contexts/adminContext/adminContext';
import useTranslation from '../../../hooks/translation/useTranslation';

export default function HeaderServerTimer() {
  const { trans } = useTranslation();
  const timerRef = useRef(null);
  const { serverCurrentTime } = useContext(AdminContext);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timerRef.current && serverCurrentTime) {
        if (timerRef.current.innerHTML) {
          timerRef.current.innerHTML = moment.utc(timerRef.current.innerHTML).add(1, 'second').format('YYYY-MM-DD HH:mm:ss');
        } else {
          timerRef.current.innerHTML = moment.utc(serverCurrentTime).add(1, 'second').format('YYYY-MM-DD HH:mm:ss');
        }
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [serverCurrentTime]);
  return (
    <div className="flex gap-2 text-[14px]">
      {trans('serverTime')}
      :
      <div ref={timerRef} />
    </div>
  );
}
